import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export const StatsCard = ({ title, value, trend, trendValue, icon: Icon, testId }) => {
  return (
    <div className="stats-card" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm text-[var(--tms-text-secondary)] font-medium">{title}</p>
          <p className="text-3xl font-bold text-[var(--tms-text)] mt-2 font-mono">{value}</p>
          {trend && (
            <div className="flex items-center gap-1 mt-2">
              {trend === 'up' && <TrendingUp className="w-4 h-4 text-green-500" />}
              {trend === 'down' && <TrendingDown className="w-4 h-4 text-red-500" />}
              {trend === 'neutral' && <Minus className="w-4 h-4 text-[var(--tms-text-muted)]" />}
              <span className={`text-sm ${
                trend === 'up' ? 'text-green-500' : 
                trend === 'down' ? 'text-red-500' : 
                'text-[var(--tms-text-muted)]'
              }`}>
                {trendValue}
              </span>
            </div>
          )}
        </div>
        {Icon && (
          <div className="w-12 h-12 rounded-lg bg-[var(--tms-card)] border border-[var(--tms-border)] flex items-center justify-center">
            <Icon className="w-6 h-6 text-blue-500" />
          </div>
        )}
      </div>
    </div>
  );
};